import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import About from "./About";
import ViewCompanyDetailsHeader from "./ViewClientDetailsHeader";

export default function ViewCategoryDetails() {
  const location = useLocation();
  const navigate = useNavigate();
  const clientData = location?.state?.clientData;
  const [step, setStep] = useState(1);

  const handleStepChange = (newStep) => setStep(newStep);

  const renderStep = () => {
    switch (step) {
      case 1:
        return (
          <>
            <About clientData={clientData} />
          </>
        );
      case 2:
        return <>{/* Add Step 2 content here */}</>;
      case 3:
        return <>{/* Add Step 3 content here */}</>;
      case 4:
        return <>{/* Add Step 4 content here */}</>;
      default:
        return null;
    }
  };

  return (
    <>
  <div className="content">
    <div className="container-fluid">
      <div className="d-flex justify-content-lg-start mb-3">
        <button
          type="button"
          className="btn btn-light"
          onClick={() => navigate(-1)}
        >
          <i className="bi bi-arrow-left"></i>
        </button>
      </div>

      <div className="row justify-content-center">
        <div className="col-sm-8">
          <div className="card mt-5">
            <div className="card-body p-4">
              <h5 className="text-center mb-4">Category Information</h5>

              {/* Edit Button */}
              <button
                type="button"
                className="btn btn-soft-danger position-absolute"
                style={{ top: "10px", right: "10px" }}
                onClick={() =>
                  navigate(`/manage_category/edit_category`, {
                    state: { clientData },
                  })
                }
              >
                <i className="ri-settings-2-line align-text-bottom me-1 fs-16 lh-1"></i>
                Edit
              </button>

              {/* Profile Details */}
              <div className="row mb-3">
                <div className="col-md-4">
                  <strong>Name:</strong>
                </div>
                <div className="col-md-8">
                  {clientData?.name || "N/A"}
                </div>
              </div>

              <div className="row mb-3">
                <div className="col-md-4">
                  <strong>Description:</strong>
                </div>
                <div className="col-md-8">
                  {clientData?.description || "N/A"}
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</>

  );
}
